module.exports = __webpack_public_path__ + "img/908118605.55570839.jpg";